import React from 'react';
import './hero-details.css'


const HeroDetails = () => {
    return ( <>
    <div className='hero-container2'>
    <div className='background-pic'>
        <div className='text-container'>
    <h1 className='title2'>Your Next Chapter Starts Here</h1>
    <p className='subtitle'>Premium villas and apartments in elite locations</p>
    </div>
    </div>
    </div>
    </> );
}
 
export default HeroDetails;